var $1c06841dd4943618$exports = {};
$1c06841dd4943618$exports = {
    "info": `Teave`,
    "negative": `Viga`,
    "positive": `Valmis`
};


export {$1c06841dd4943618$exports as default};
//# sourceMappingURL=et-EE.mjs.map
